import styled, { css } from 'styled-components';

import ImageLoading from 'images/verify/loading-ellipsis.svg';

const InlineImage = styled('div')<InlineLoadingIndicatorProps>`
  display: inline-block;
  width: 20px;
  ${(props) =>
    props.dark &&
    css`
      filter: invert(0.8) brightness(250%);
    `};

  svg {
    vertical-align: baseline;
  }
`;

interface InlineLoadingIndicatorProps {
  className?: string;
  dark?: boolean;
}

const InlineLoadingIndicator = ({ className, dark }: InlineLoadingIndicatorProps) => (
  <InlineImage
    dark={dark}
    className={className}
    role='progressbar'
    // note that more content is coming
    aria-busy
    // lower priority for screen readers
    aria-live='polite'
  >
    <ImageLoading />
  </InlineImage>
);

export default InlineLoadingIndicator;
